//**************************************************************
// 1. scroll fadein animation
//**************************************************************
$(window).scroll(function () {
  $(".fadeInUp").each(function () {
    var elemPos = $(this).offset().top,
      scroll = $(window).scrollTop(),
      windowHeight = $(window).height();

    if (scroll > elemPos - windowHeight + 100) {
      $(this).addClass("scrollin");
    }
  });
});


//**********************************************************************
// 4. ハンバーガーメニューのメニュークリック後に 閉じる
//**********************************************************************
$(function () {
  $(".modal-close").on("click", function (event) {
    $("#sp-modal-nav").prop("checked", false);
  });
});

//**********************************************************************
// 5. ハンバーガーメニューの起動
//**********************************************************************
$(function () {
  $(".hamburger").click(function () {
    $(this).toggleClass("active");

    if ($(this).hasClass("active")) {
      $(".menu-contents").addClass("active");
    } else {
      $(".menu-contents").removeClass("active");
    }
  });
});

//**********************************************************************
// 6.TOPわっか専用スライドショー
//**********************************************************************
// 進むボタン
window.replaceClass = function () {
  let class_name = "slide";
  let slides = document.getElementsByClassName("slides"); // 6枚の現在のクラス名を取得

  // console.log(slides);

  for (let i = 0; i < 6; ++i) {
    // slide1
    current_classs_name = slides[i].classList[0];
    // そのnoを変数に入れる　current_no
    let current_no = Number(current_classs_name.slice(-1));

    if (current_no == 6) {
      slides[i].classList.replace(current_classs_name, class_name + 1); // slide6がslide1に置き換わる
    } else {
      slides[i].classList.replace(
        current_classs_name,
        class_name + (current_no + 1)
      ); // slide1がslide2に置き換わる
    }
  }
};

window.replaceClassPrev = function () {
  let class_name = "slide";
  let slides = document.getElementsByClassName("slides"); // 6枚の現在のクラス名を取得

  console.log(slides);

  for (let i = 0; i < 6; ++i) {
    // slide1
    current_classs_name = slides[i].classList[0];
    // そのnoを変数に入れる　current_no
    let current_no = Number(current_classs_name.slice(-1));

    if (current_no == 1) {
      slides[i].classList.replace(current_classs_name, class_name + 6); // slide1がslide6に置き換わる
    } else {
      slides[i].classList.replace(
        current_classs_name,
        class_name + (current_no - 1)
      ); // slide2がslide1に置き換わる
    }
  }
};


//**********************************************************************
// FADE IN ANIMATION（画面遷移）
//**********************************************************************
$(window).on('load', function(){
  $('body').removeClass('fadeout');
});

$(function() {
  // ハッシュリンク(#)と別ウィンドウでページを開く場合はスルー
  $('a:not([href^="#"]):not([target])').on('click', function(e){
    e.preventDefault(); // ナビゲートをキャンセル
    url = $(this).attr('href'); // 遷移先のURLを取得
    if (url !== '') {
      $('body').addClass('fadeout');  // bodyに class="fadeout"を挿入
      setTimeout(function(){
        window.location = url;  // 0.8秒後に取得したURLに遷移
      }, 800);
    }
    return false;
  });
});

// 戻るボタンが押された際の処理
window.onpageshow = function(event) {
  if (event.persisted) {
    $('body').removeClass('fadeout');
  }
};

